module.exports = __webpack_public_path__ + "media/printed-materials/06-educator-high-school-calendar-c6cc7e17.jpg";